/* What an overlay is placed against. Usually the trigger element, but it may
   be any other element or a VIRTUAL rect: an object that only reports a
   viewport rect, such as a text caret or a pointer position. usePosition
   reads only the rect, so both kinds place the same way. A virtual rect has
   no DOM node, so it never counts as inside for an outside press and never
   takes focus; these helpers are the one place that tells the kinds apart. */

/** An anchor with no DOM node: only its viewport rect. */
export interface VirtualAnchor {
  getBoundingClientRect(): DOMRect;
}

/** A DOM element or a virtual rect. */
export type PositionAnchor = Element | VirtualAnchor;

/** The anchor's DOM element, or null for a virtual rect. Checks `nodeType`
 *  rather than `instanceof Element`, so an element from another realm still
 *  counts as an element. */
export function anchorElement(
  anchor: PositionAnchor | null | undefined,
): Element | null {
  return anchor != null && (anchor as Partial<Node>).nodeType === 1
    ? (anchor as Element)
    : null;
}

/** Focus the anchor when it is a connected element that can take focus. A
 *  virtual rect has no node, so focus stays where it is. */
export function focusAnchor(anchor: PositionAnchor | null | undefined): void {
  const el = anchorElement(anchor) as HTMLElement | null;
  if (el?.isConnected) el.focus?.();
}
